import { AppLayout } from '@/components/layout/AppLayout';
import { Menu } from '@/components/layout/Menu';
import { SpriteSvg } from '@/components/common/SpriteSvg';
import { Link, Navigate, useParams } from 'react-router-dom';
import { useChannel } from '@/hooks/api/useChannel';
import { useState } from 'react';
import { DeltaJsonElement } from '@/components/common/DeltaJsonElement';
import { ChannelPostList } from '@/components/features/channels/[cid]/ChannelPostList';
import { ChannelPostTile } from '@/components/features/channels/[cid]/ChannelPostTile';
import { SnsIcons } from '@/components/features/channels/[cid]/SnsIcons';
import { Error404 } from '@/features/404';
import { Helmet } from 'react-helmet-async';

export const Channel = () => {
  const params = useParams<{ cid: string }>();
  const { data: channel, isError } = useChannel(params.cid!);
  const [tileDisplay, setTileDisplay] = useState<boolean>(true);

  if (isError) return <Navigate replace to={`/`} />;

  if (channel == null) return <></>;

  console.log(channel.profile_text);

  return (
    <AppLayout type={'creator'}>
      <Helmet>
        <title>{channel.name}</title>
        <meta name="description" content={channel.profile_text} />
        <meta property="og:description" content={channel.profile_text} />
      </Helmet>
      <div className="global-container">
        <Menu />
        <label htmlFor="menu-opener" className="floating-menu-opener">
          <SpriteSvg name={'icon-floating-menu'} className={'i'} />
        </label>

        <div className="content-main creator">
          <section className="creator color01">
            <div className="wrapper">
              <img src={channel.profile_image_url} className="cover" />
              <img src={channel.icon_url} className="icon" />
            </div>
            <div className="name-wrapper">
              <div className="name">{channel.name}</div>
              <SnsIcons channel={channel} />
            </div>
            <input type="checkbox" id="details-opener" className="opener-checkbox" />
            <div className="details">
              <DeltaJsonElement keyPrefix={`channel_profile_${channel.id}`} deltaJson={channel.profile_json} />
              {/*<label htmlFor="details-opener" className="details-opener">*/}
              {/*  <SpriteSvg name={'icon-arrow-down'} className={'i'} />*/}
              {/*</label>*/}
            </div>
            <input type="checkbox" className="opener-checkbox" id="post-type-opener" />
          </section>

          <section className="tab t2">
            <Link
              to={`/channels/${channel.cid}`}
              className={tileDisplay ? 'active' : ''}
              onClick={() => setTileDisplay(true)}
            >
              {channel.posts_count} ポスト
            </Link>
            <Link
              to={`/channels/${channel.cid}`}
              className={tileDisplay ? '' : 'active'}
              onClick={() => setTileDisplay(false)}
            >
              タイムライン
            </Link>
          </section>

          {tileDisplay ? <ChannelPostTile cid={channel.cid} /> : <ChannelPostList cid={channel.cid} />}
        </div>
      </div>
    </AppLayout>
  );
};
